import { render, staticRenderFns } from "./SageTransactions.vue?vue&type=template&id=4fef7259&"
import script from "./SageTransactions.vue?vue&type=script&lang=js&"
export * from "./SageTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports